module.exports = __webpack_public_path__ + "static/cateau3-6548673068fba4954a3afb2d367ee441.webp";